import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['item'];

  initialize() {
    window.console.log('Sortable Controller Initialized!');
  }

  connect() {
    // Get perPage from dataset or default to all items if not paginated
    const perPage = parseInt(this.element.dataset.sortablePerPageValue, 10) || this.itemTargets.length;
    const currentPage = this.getCurrentPage();
    const pageOffset = (currentPage - 1) * perPage;
    // A table that shows only part of a positioned list (the task page's
    // Task Measurements below its Setup Measurements) starts after the rest.
    const baseOffset = parseInt(this.element.dataset.sortableOffset, 10) || 0;

    const axis = this.element.dataset.sortableAxis || false;
    // Default handle, overridable so nested sortables (e.g. sections vs their own
    // parameters) can use distinct handles and not trigger each other.
    const handle = this.element.dataset.sortableHandle || '[name=sort_handle]';

    $(this.element).sortable({
      handle: handle,
      tolerance: 'pointer',
      items: '> [data-target="sortable.item"]',
      cursor: 'move',
      axis: axis,
      stop: () => {
        $.each(this.itemTargets, (i, item) => {
          const { url, model } = $(item).data();
          const globalPosition = baseOffset + pageOffset + i + 1;

          const data = {};
          data[model] = { position: globalPosition };

          $.ajax({
            method: 'PATCH',
            url: `${url}?do_not_update_ui=true`,
            data,
            dataType: 'script',
            headers: { 'X-CSRF-Token': Rails.csrfToken() },
          });
        });
      },
    });

    // Re-scan for items appended after init (e.g. by infinite scroll) so they
    // become draggable without a full page reload.
    this.refreshSortable = () => {
      try { $(this.element).sortable('refresh'); } catch (_) { /* not initialized */ }
    };
    this.element.addEventListener('sortable:rescan', this.refreshSortable);
  }

  disconnect() {
    if (this.refreshSortable) {
      this.element.removeEventListener('sortable:rescan', this.refreshSortable);
    }
  }

  getCurrentPage() {
    const urlParams = new URLSearchParams(window.location.search);
    return parseInt(urlParams.get('page')) || 1; // Defaults to page 1 if not specified
  }
}
